module.exports = __webpack_public_path__ + "static/media/sologo.ee9e6855.png";